import React from 'react';
import { Space } from 'antd';
import logo from '../assets/image/logo_w@2x.png';
import guochanIcon from '../assets/image/icon/icon_guochan@2x.png';
import kuorongIcon from '../assets/image/icon/icon_kuorong@2x.png';
import xingnengIcon from '../assets/image/icon/icon_xingneng@2x.png';
import gantanIcon from '../assets/image/icon/icon_gantan@2x.png';
import gouIcon from '../assets/image/icon/icon_gou@2x.png';
import icon_wechat from '../assets/image/icon/icon_wechat_h.png';
import icon_wechat_h from '../assets/image/icon/img_qrcode_20210120.png';
import icon_wechat_m from '../assets/image/icon/icon_WeChat@2x.png'
import icon_dianzan from '../assets/image/icon/icon_dianzan@2x.png';
import img_weihu from '../assets/image/bg/img_weihu@2x.png';
import img_shensuo from '../assets/image/bg/img_shensuo@2x.png';
import img_chengben from '../assets/image/bg/img_chengben@2x.png';
import img_gcxc from '../assets/image/bg/img_gcxc@2x.png';
import img_kuorong from '../assets/image/bg/img_kuorong@2x.png';
import img_shiyan from '../assets/image/bg/img_shiyan@2x.png';
import img_guochan from '../assets/image/bg/img_guochan@2x.png';
import img_keyong from '../assets/image/bg/img_keyong@2x.png';
import img_bg2 from '../assets/image/bg/img_bg2@2x.png';
import img_bg3 from '../assets/image/bg/img_bg3@2x.png';
import img_bg4 from '../assets/image/bg/img_bg4@2x.png';
import img_changjing from '../assets/image/bg/img_changjing@2x.png';
import img_anli from '../assets/image/bg/img_anli@2x.png';
import img_anli1 from '../assets/image/bg/img_anli1@2x.png';
import img_anli2 from '../assets/image/bg/img_anli2@2x.png'
import Content1 from './Content/Content1';
import Content2 from './Content/Content2';
import Content3 from './Content/Content3';
import Content4 from './Content/Content4';
import Content5 from './Content/Content5';
export const HeaderDataSource = {
  logo: {
    src: logo,
    title: '小盾未来科技旗下品牌'
  },
  menu: [
    {
      title: '客户痛点与解决方案',
      key: '1',
      href:'#customer-pain-point'
    },
    {
      title: '产品特性',
      key: '2',
      href:'#product-feature'
    },
    {
      title: '核心功能',
      key: '3',
      href:'#core-function'
    },
    {
      title: '适用场景',
      key: '4',
      href:'#applicable-scene'
    },
    {
      title: '成功案例',
      key: '5',
      href:'#success-case'
    },
  ]
};

export const BannerDataSource = [
  {
    title: 'ApexDB（兼容Redis）',
    subTitle:'信创分布式高性能KV数据库',
    desc: 'ApexDB是小盾未来科技自主研发的分布式高性能多线程KV数据库，采用Share-Nothing架构设计，单节点最高可到百万级TPS和1毫秒延迟。尤其针对决策场景，产品内置了原生的常用算子，可以在<1ms内完成计算存储一体化请求。',
    btns: [
      {
        title: '立即申请',
        className: 'banner-content-btns-item',
        type: 'primary',
        target:'_blank',
        href: 'https://www.xiaodun.com/register'
      },
      {
        title: '产品文档',
        className: 'banner-content-btns-item btn-ghost',
        type: 'ghost',
        target: '_blank',
        ghost: true,
        href: 'https://apexdb.tongdun.cn'
      }
    ],
    bannerTabs: [
      { icon: guochanIcon, title: '国产化自主可控' },
      { icon: kuorongIcon, title: '毫秒级响应与分钟级扩容' },
      { icon: xingnengIcon, title: '高性能特征指标计算' }]
  },
];


export const FooterDataSource = {
  wrapper: { className: 'home-page-wrapper footer-wrapper' },
  OverPack: { className: 'footer', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>快速入口</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: 'https://xiaodun.com/',
              target:'_blank',
              children: (
                <span>
                  小盾未来
                </span>
              ),
            },
            // {
            //   name: 'link1',
            //   target:'_blank',
            //   href: 'https://www.xiaodun.com/',
            //   children: (
            //     <span>
            //       小盾安全
            //     </span>
            //   ),
            // },
            {
              name: 'link2',
              href: 'https://zhongboxin.com/',
              target:'_blank',
              children: (
                <span>
                  中博信征信
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: { children: '关于小盾未来' },
        childWrapper: {
          children: [
            { style: { width: "100%", display: 'inline-block' }, href: 'https://www.xiaodun.com/info/company', name: 'link0', children: '小盾未来介绍' },
            // { style: { width: "100%", float: 'none', display: 'inline-block' }, href: 'https://app.mokahr.com/apply/tongdun/29005#/', name: 'link1', children: '小盾未来科技招聘' },
            { style: { width: "100%", display: 'inline-block' }, href: 'https://xiaodun.com/info/newslist', name: 'link2', children: '小盾未来动态' },
            { style: { width: "100%", float: 'none', display: 'inline-block' }, href: 'https://xiaodun.com/other/security', name: 'link5', children: '小盾未来安全' },
            { style: { width: "100%", float: 'none', display: 'inline-block' }, href: 'https://xiaodun.com/other/guarantee', name: 'link3', children: '权益保障' },
            { style: { width: "100%", display: 'inline-block' }, href: 'https://xiaodun.com/info/contact', name: 'link4', children: '联系我们' },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>服务与支持</p>
            </span>
          ),
          className: 'k9h7k134cu-editor_css',
        },
        childWrapper: {
          children: [
            { name: 'link0', style: {marginBottom:'20px'}, children: '售后服务：service@xiaodun.com' },
            { name: 'link1', style: { marginBottom: '20px' }, children: '商务合作：mkt@xiaodun.com' },
            { name: 'link2', style: { marginBottom: '20px' }, children: '工作时间：9:00 - 18:00(工作日)' },
          ],
        },
      },
      {
        name: 'block4',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>电话咨询</p>
            </span>
          ),
          className: 'k9h7k134cu-editor_css',
        },
        childWrapper: {
          children: [
            { name: 'link0', style: { marginBottom: '20px' }, children: '电话咨询：400-068-9796' },
            {
              name: 'link1', style: { marginBottom: '20px' }, children: '专有云咨询：400-068 - 9796转3' },
            {
              name: 'link2', style: { marginBottom: '20px' }, children: '公有云咨询：400-068 - 9796转2'
            },
            {
              name: 'link3', style: { marginBottom: '20px' }, children: '售前咨询：400 -068 - 9796转1'
            },

          ],
          extra: {
            smallImg: icon_wechat,
            hoverImg: icon_wechat_h,
          }
        },
      },
    ],
  },
  link: {
    title: '友情链接',
    children: [
      {target:'_blank', href: 'https://www.pcac.org.cn/', children: '中国支付清算协会' },
      { target: '_blank', href: 'https://www.nifa.org.cn/nifa/index.html', children: '中国互联网金融协会' },
      { target: '_blank', href: 'https://www.china-cba.net/', children: '中国行业协会' },
      { target: '_blank', href: 'https://www.zju.edu.cn/', children: '浙江大学' },
      { target: '_blank', href: 'http://www.ust.hk/', children: '香港科技大学' },
      { target: '_blank', href: 'https://www.nwpu.edu.cn/', children: '西北工业大学' },
      { target: '_blank', href: 'https://www.theasianbanker.com/', children: '亚洲银行家' },
      { target: '_blank', href: 'http://www.thfr.com.cn/', children: '清华金融评论' },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <Space size={16}>
        <span>Copyright ©2026 浙江小盾未来科技有限公司版权所有 </span>
        <a target='_blank' href='https://beian.miit.gov.cn/'>浙ICP备12036190号 </a>
        <a target='_blank'  href='https://beian.mps.gov.cn/#/query/webSearch'>浙公网安备33011002010541号 </a>
        <a >组织机构代码:05368706-1 </a>
        <a target='_blank' href='https://tongdun.com/other/privacy/id=1'> 隐私政策 </a>
        <a href='https://tongdun.com/other/privacy/id=2'> 信贷风控SLA </a>
        <a href='https://tongdun.com/other/privacy/id=4'>设备指纹SDK隐私政策 </a>
      </Space>
    ),
  },
  mobile: {
    title: '关于我们',
    subTitle: '关注我们',
    btn: { title: '售前咨询', tel: '400-068-9796' },
    icon: {
      smallImg: icon_wechat_m,
      hoverImg: icon_wechat_h,
},
    children: [
      { name: 'link0', children: '售后服务：service@tongdun.cn' },
      { name: 'link1', children: '商务合作：mkt@tongdun.cn' },
      { name: 'link2', children: '工作时间：9:00-18:00（工作日）' },
    ],
    copyright: 'Copyright @2026 浙江小盾未来科技有限公司版权所有'
  }
};

export const ContentDataSource = [{
  id: 'customer-pain-point',
  title: '面临的挑战与解决之道',
  subTitle:'Challenges & Solutions',
  content: <Content1 />,
}, {
  id: 'product-feature',
  title: '非凡显著的产品特性',
  subTitle: 'Product features',
  background: `url(${img_bg2})` ,
    content: <Content2/>,
  }, {
  id:'core-function',
  title: '高效易用的核心功能',
  subTitle: 'Core functions',
  background: `url(${img_bg3})`,
    content: <Content3/>,
  }, , {
  id:'applicable-scene',
  title: '贴合实际的适用场景',
  subTitle: 'Applicable scenarios',
  background: `url(${img_bg4})` ,
    content: <Content4 />,
  }, , {
  id:'success-case',
  title: '效果显著的客户案例',
    titleClassName: 'content5-title',
  subTitle: 'client cases',
  background: 'linear-gradient(180deg, #1C2437 0%, #3C4963 100%)',
    content: <Content5 />,
            }];


export const Content1DataSource = {

  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  Carousel: {
    className: 'content1-content',
    dots: false,
    wrapper: { className: 'content1-content-wrapper' },
    titleWrapper: {
      className: 'content1-title-wrapper',
      barWrapper: {
        className: 'content1-title-bar-wrapper',
        children: { className: 'content1-title-bar' },
      },
      title: { className: 'content1-title' },
    },
    children: [
      {
        title: { className: 'content1-title-text', children: '国产信创' },
        className: 'content1-item',
        name: 'block0',
        backgroundImg: img_gcxc,
        children: [{
          className: 'content1-list content1-list-red',
          icon:gantanIcon,
          title: { className: 'content1-list-title', children: <span>国产信创，<br/>安全自主可控组件要求</span> },
          list: [{ text: '“脱钩断链”规避卡脖子风险；' }, { text: '“应替尽替”监管要求2027年完成信创100%全替代；' }, { text: '“长期经营”角度满足自主可控组件 国产信创要求；' }]
        }, {
          className: 'content1-list content1-list-blue',
          icon: gouIcon,
          title: { className: 'content1-list-title', children: '信创国产化' },
          list: [{ text: '全供应链国产化；' }, { text: '具备信创支持认证；' }, { text: '提供国密算法支持；' }]
          }],
      },
      {
        title: { className: 'content1-title-text', style: { textAlign: 'center' }, children: '业务增长快' },
        className: 'content1-item',

        name: 'block1',
        backgroundImg: img_shensuo,
        children: [{
          className: 'content1-list content1-list-red ',
          icon: gantanIcon,
          title: { className: 'content1-list-title', children: <span>业务增长快，<br />需弹性扩缩容、容灾</span>   },
          list: [{ text: '支撑高业务连续性要求；' }, { text: '作为基础资源，海量数据“扩容难度高”；' }, { text: '应用于关键业务系统“容灾考量重”；' }]
        }, {
          className: 'content1-list content1-list-blue',
          icon: gouIcon,
          title: { className: 'content1-list-title', children: '弹性伸缩' },
          list: [{ text: '分布架构设计，解决单点故障保障高可用；' }, { text: '“多线程”解决高并发、高吞吐能力；' }, { text: '“Share-Nothing”设计解决按需弹性伸缩；' }]
        }],
      },
      {
        title: { className: 'content1-title-text', style: { textAlign: 'center' }, children: '运维难、使用难' },
        className: 'content1-item',
        name: 'block2',
        backgroundImg: img_weihu,
        children: [{
          className: 'content1-list content1-list-red',
          icon: gantanIcon,
          title: { className: 'content1-list-title', children: <span>运维难、使用难，<br />金融业务连续性保障要求</span> },
          list: [{ text: <span>集群管理难<div className='content1-list-title-subtitle'>随着业务发展需要，计算规模大，KV数据库集群难管理；</div></span> },
            { text: <span>日常维护难<div className='content1-list-title-subtitle'>一些产品配套的管理工具链不完善，故障备份恢复等；</div></span>  },
            { text: <span>服务商转型<div className='content1-list-title-subtitle'>主营业务的服务商的可持续性延续性受到挑战；</div></span> }]
        }, {
          className: 'content1-list content1-list-blue',
          icon: gouIcon,
          title: { className: 'content1-list-title', children: '高可维护性' },
          list: [{ text: '完善的工具链体系；' }, { text: '便利的集群管理，扩缩容简单；' }, { text: '无缝Redis迁移，全面兼容Redis；' }]
        }],
      },
      {
        title: { className: 'content1-title-text', style: { textAlign: 'right' }, children: '成本控制' },
        className: 'content1-item',
        name: 'block3',
        backgroundImg: img_chengben,
        children: [{
          className: 'content1-list content1-list-red',
          icon: gantanIcon,
          title: { className: 'content1-list-title', children: <span>成本、成本<br />还是成本</span> },
          list: [{ text: '目前市场KV存储多使用内存；' }, { text: '当前是作为最贵的基础资源；' }, { text: '是SSD价格的100倍；' }, { text: '物理机强需求，存在节点扩容难；' }]
        }, {
          className: 'content1-list content1-list-blue',
          icon: gouIcon,
          title: { className: 'content1-list-title', children: '成本控制' },
          list: [{ text: 'SSD 替代内存，大幅降低资源成本；' }, { text: '完善的工具链，极大降低后续运维成本；' }, { text: '成本与性能平衡，在较高的性能下降低成本；' }]
        }],
      },
    ],
  },
    };


export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper content2-wrapper' },
  page: { className: 'home-page content2' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
    className: 'content2-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'jzjn8afnsxb-editor_css content2-block',
        children: {
          className: 'content2-block-item jzjgrrupf2c-editor_css',
          bgImg: img_guochan,
          children: [
            {
              name: 'title',
              className: 'content2-block-title jzj8xt5kgv7-editor_css',
              children: '国产化',
            },
            {
              name: 'content',
              children: '拥有多项国产软著、专利、商标等认证；此外支持服务端用户名密码鉴权、SM4国密和AES数据透明加密等安全机制',
              className: 'content2-block-content',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content2-block',
        children: {
          className: 'content2-block-item',
          bgImg: img_kuorong,
          children: [
            {
              name: 'title',
              className: 'content2-block-title jzjne54fwqm-editor_css',
              children: '1分钟无感扩容',
            },
            {
              name: 'content',
              className: 'content2-block-content',
              children: '作为分布式数据库，扩缩容不影响性能和在线服务，且集群会自动进行数据平衡和迁移，最高可支持128个节点',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content2-block',
        children: {
          className: 'content2-block-item',
          bgImg: img_keyong,
          children: [
            {
              name: 'title',
              className: 'content2-block-title jzjne24af8c-editor_css',
              children: '99.99%可用',
            },
            {
              name: 'content',
              className: 'content2-block-content',
              children: '稳定支撑60+金融客户，3年0故障。拥有自我保护机制，可自动限流热点和异常请求，且任意节点宕机均不会影响在线服务',
            },
          ],
        },
      },
      {
        name: 'block~jzjn87bmyc7',
        className: 'content2-block',
        children: {
          className: 'content2-block-item',
          bgImg: img_shiyan,
          children: [
            {
              name: 'title',
              className: 'content2-block-title jzjndw5oerk-editor_css',
              children: '1毫秒时延',
            },
            {
              name: 'content',
              className:'content2-block-content',
              children: '通过OpenSAO与内嵌服务端UDF，实现超高性能查询与计算，单机TPS最高可达150万（最新代高配云服务器），P999延迟低于1ms',
            },
          ],
        },
      },
    ],
  },
    };



export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.3 },
  blockWrapper: {
    className: 'content3-block-wrapper',
    gutter: 24,
    children: [
      {
        md: 8,
        xs: 24,
        name: 'block0',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-blue',
          children: [
            {
              name: 'title',
              className: 'content3-block-title',
              children: '标准KeyValue',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '数据类型可支持整型、双精浮点数、字符串、二进制数组等。',
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: 'block1',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-blue',
          children: [
            {
              name: 'title',
              className: 'content3-block-title',
              children: '多种存储引擎',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '目前提供SSD引擎、纯内存引擎，可根据需求场景灵活配置。',
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: 'block2',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-blue',
          children: [
            {
              name: 'title',
              className: 'content3-block-title',
              children: '服务端UDF功能',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '开发者可使用LUA或C/C++开发自定义的服务端计算函数并在运行时动态载入数据库内核。',
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: 'block3',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-blue',
          children: [
            {
              name: 'title',
              className: 'content3-block-title',
              children: '多租户支撑',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '支持同一集群划分多个受控的逻辑单元以承载多种业务从而降低管理和运维成本。',
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: 'block4',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-blue',
          children: [
            {
              name: 'title',
              className: 'content3-block-title',
              children: '复杂集合类型',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '主要包括map和list集合数据结构，提供了大量语义丰富的计算算子，这些集合均可支持所有标准数据类型。',
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: 'block5',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-blue',
          children: [
            {
              name: 'title',
              className: 'content3-block-title',
              children: '运行时动态配置',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '数据库提供了60多项运行时动态可调配置，方便DBA根据实际情况进行在线调优。',
            },
          ],
        },
      },
      {
        md: 12,
        xs: 24,
        name: 'block6',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-red',
          children: [
            {
              name: 'image',
              className: 'content3-block-image',
              children:icon_dianzan,
            },
            {
              name: 'title',
              className: 'content3-block-title content3-block-title-red',
              children: '国密加密',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '在落盘时自动对记录执行标准的SM4加密，确保数据安全性，ApexDB是市面上为数不多支持国密的数据库产品。',
            },
          ],
        },
      },
      {
        md: 12,
        xs: 24,
        name: 'block7',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-red',
          children: [
            {
              name: 'image',
              className: 'content3-block-image',
              children: icon_dianzan,
            },
            {
              name: 'title',
              className: 'content3-block-title content3-block-title-red',
              children: 'OpenSAO',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '小盾未来科技独有的开放式服务端高级算子OpenSAO：可根据我们提供的SDK使用C/C++/Rust开发动态库模块，运行时动态加载到数据库内，实现个性化业务逻辑。特别适合于对数据安全性或保密性有特殊需求的客户。',
            },
          ],
        },
      },
      {
        md: 12,
        xs: 24,
        name: 'block7',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-red',
          children: [
            {
              name: 'image',
              className: 'content3-block-image',
              children: icon_dianzan,
            },
            {
              name: 'title',
              className: 'content3-block-title content3-block-title-red',
              children: '增量平衡和持久化索引',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '可以极大降低数据自动平衡时间过长（长达十几小时）的问题，启用增量迁移后，重启一台节点总时间缩减为原来的1/8~1/10左右。',
            },
          ],
        },
      },
      {
        md: 12,
        xs: 24,
        name: 'block7',
        className: 'content3-block',
        children: {
          className: 'content3-block-group content3-block-group-red',
          children: [
            {
              name: 'image',
              className: 'content3-block-image',
              children: icon_dianzan,
            },
            {
              name: 'title',
              className: 'content3-block-title content3-block-title-red',
              children: 'BatchUDF',
            },
            {
              name: 'content',
              className: 'content3-block-content',
              children: '小盾未来科技独有的批量UDF功能：可在服务端批量执行计算存储一体化请求。',
            },
          ],
        },
      },
    ],
  },
    };


export const Content4DataSource = {
  wrapper: { className: 'home-page-wrapper content4-wrapper' },
  page: { className: 'home-page content4' },
  OverPack: { playScale: 0.3 },
  backgroundImg: {
    src: img_changjing,
    className: 'content4-bgimg'
  } ,
  blockWrapper: {
    className: 'content4-block-wrapper',
    gutter: 24,
    children: [
      {
        md: 12,
        xs: 24,
        name: 'block1',
        className: 'content4-block',
        children: {
          className: 'content4-block-group content4-block-left',
          children: [
            {
              name: 'title',
              className: 'content4-block-title',
              children: '高性能实时特征指标计算场景',
            },
            {
              name: 'content',
              className: 'content4-block-content',
              children: '例如实时反欺诈场景下，行为类指标实时计算及更新场景，响应时间可低至1ms',
            }],
        },
      },
      {
        md: 12,
        xs: 24,
        name: 'block1',
        className: 'content4-block',
        children: {
          className: 'content4-block-group content4-block-right',
          children: [
            {
              name: 'title',
              className: 'content4-block-title',
              children: '海量数据存储和高性能查询场景',
            },
            {
              name: 'content',
              className: 'content4-block-content',
              children: '例如实时反欺诈场景下，设备指纹、名单库的存储与实时查询场景，数据规模可支撑100TB+',
            }],
        },
      }],
  },
};


export const Content5DataSource = {
  leftBgImg: {
    src: img_anli,
    className: 'content5-left-bgimg'
  },
  OverPack: { playScale: 0.3 },
  blockWrapper: {
    className: 'content5-block',
    children: [{
      top: {
        playScale: 0.3 ,
        className: 'content5-block-top',
        children: [{
          name: 'title', children: '某大型国有银行名单库项目',
          className:'content5-block-top-title'
        }, {
          name: 'content', children: '某大型国有银行面临日益增长的欺诈交易风险（如盗刷、账户盗用），面对每天数十亿的交易量和名单数，当前的名单库系统面临严峻挑战。 ',
          className: 'content5-block-top-content'
        }]
      },
      middle: {
        playScale: 0.3 ,
        className: 'content5-block-middle',
        children: [
          {
            name: 'title', children: '客户痛点', className: 'content5-block-title',
          },
          {
            name: 'array', children: [{
              md: 12,
              className: "content5-block-middle-content",
              children: [
                { name: 'title', className: 'content5-block-middle-content-title', children: '扩容复杂：' },
                { name: 'content', className: 'content5-block-middle-content-content', children: '随着业务量迅猛增长，存储空间日益紧张，但Redis集群扩容运维操作非常复杂，需要人工干预进行分片均衡，平均耗时5h以上。' }
              ]
            }, {
              md: 12,
              className: "content5-block-middle-content",
              children: [
                { name: 'title', className: 'content5-block-middle-content-title', children: '成本高昂：' },
                { name: 'content', className: 'content5-block-middle-content-content', children: 'Redis属于单线程单实例存储，导致其计算资源利用率低下，带来高额的机器成本。' }
              ]
            }]
          },
        ]
      },
      bottom: {
        playScale: 0.3 ,
        className: 'content5-block-bottom',
        children: [{
          name: 'title', children: '项目效果',className:'content5-block-title',
        }, {
          name: 'array',
          children: [{
              // md: 12,
            className: "content5-block-bottom-content",
            style: {
              backgroundImage: `url(${img_anli1})`,
              width: 250,
              marginRight:20
            },
            children: [
              { name: 'num', className: 'content5-block-bottom-content-num', children: '60' },
              { name: 'title', className: 'content5-block-bottom-content-title', children: '运维提效60倍' },
              { name: 'content', className: 'content5-block-bottom-content-content', children: '可自动扩容并均衡数据，减少人工投入，耗时从之前的5h+降低至5min以内。' }
                ]
            }, {
              // md: 12,
            className: "content5-block-bottom-content",
            style: {
              backgroundImage: `url(${img_anli2})`,
              width: 265,
            },
            children: [
              { name: 'num', className: 'content5-block-bottom-content-num', children: '85%' },
              { name: 'title', className: 'content5-block-bottom-content-title', children: '降低成本85%' },
              { name: 'content', className: 'content5-block-bottom-content-content', children: '在原系统情况下，需要部署360台服务器，升级后仅需54台服务器，成本降低了85%以上。' }
              ]
            }]
          },]
      },
    }, {
        top: {
          playScale: 0.3,
          className: 'content5-block-top',
          children: [{
            name: 'title', children: '某股份制银行决策引擎项目',
            className: 'content5-block-top-title'
          }, {
            name: 'content', children: '反欺诈检测范围需要继续延展。未来会持续扩宽业务监控范围，将聚合支付、电子支付、网贷业务等业务纳入实时反欺诈范围。 ',
            className: 'content5-block-top-content'
          }]
        },
        middle: {
          playScale: 0.3,
          className: 'content5-block-middle',
          children: [
            {
              name: 'title', children: '客户痛点', className: 'content5-block-title',
            },
            {
              name: 'array', children: [{
                md: 24,
                className: "content5-block-middle-content",

                children: [
                  { name: 'title', className: 'content5-block-middle-content-title', children: '投入成本高、有降本提效诉求：' },
                  { name: 'content', style: { width: "100%" }, className: 'content5-block-middle-content-content', children: '行方原决策引擎支撑业务时，指标计算存储使用redis，在日均交易量1000万多情况下，系统配置指标1000+条，系统平均响应时间需要100ms，无法满足业务数据全部接入后指标快速计算处理的底层支撑能力要求。' }
                ]
              }]
            },
          ]
        },
        bottom: {
          playScale: 0.3,
          className: 'content5-block-bottom',
          children: [{
            name: 'title', children: '项目效果', className: 'content5-block-title',
          }, {
            name: 'array',
            children: [{
              style: {
                width: 170,
                marginRight:8,
              },
              className: "content5-block-bottom-content",
              children: [
                { name: 'title', className: 'content5-block-bottom-content-title', children: '性能优越' },
                { name: 'content', className: 'content5-block-bottom-content-content', children: '日均交易量达到3000万，系统配置指标超过1000条的情况下，决策引擎系统平均响应时间降低至10ms，大大的提升了指标计算时效。' }
              ]
            }, {
              // md: 12,
              className: "content5-block-bottom-content",
              style: {
                width: 170,
                marginRight: 8,
              },
              children: [
                { name: 'title', className: 'content5-block-bottom-content-title', children: '降本增效' },
                { name: 'content', className: 'content5-block-bottom-content-content', children: '成本降低了80%以上，在原系统情况下，日均交易量3000万笔，需要部署200台服务器，升级后仅需40台服务器。' }
              ]
              },{
                className: "content5-block-bottom-content",
                style: {
                  width: 170,
                },
                children: [
                  { name: 'title', className: 'content5-block-bottom-content-title', children: '可用性高' },
                  { name: 'content', className: 'content5-block-bottom-content-content', children: '原有系统平均响应超时率5%，上线后系统平均超时率降低至0.01%以下（万分之一，500倍提升）。' }
                ]
              }]
          },]
        },
      }]
  }

};
